import { DINGY_GRAY, LIGHT_GRAY, LOW_BLUE, NEAR_WHITE } from "../../config/colors";
import styled, { css } from "styled-components";

export const Separator = styled.div`
  border-right: 1px solid ${NEAR_WHITE};
  display: inline;
  margin: 0 5px;
`;

export const Container = styled.div`
  width: max-content;
  position: fixed;
  bottom: 25px;
  display: flex;
  justify-content: center;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const TaskBarContainer = styled.div`
  background-color: ${DINGY_GRAY};
  padding: 10px 16px;
  gap: 16px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
`;

export const TaskBarItem = styled.div<{ disabled?: boolean }>`
  align-items: center;
  justify-content: center;
  display: inline-flex;
  cursor: pointer;
  color: ${NEAR_WHITE};
  font-weight: 900;
  font-size: 16px;
  line-height: 18px;
  margin: 0px 10px;

  &:hover {
    color: ${LOW_BLUE};
  }
`;

export const ArrowContainer = styled.button<{ disabled?: boolean }>`
  cursor: pointer;
  color: ${NEAR_WHITE};
  background: transparent;

  margin: 0px 16px;
  padding: 0;
  border: 0;

  &:hover {
    color: ${LOW_BLUE};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${LIGHT_GRAY};
      cursor: not-allowed;
      &:hover {
        color: ${LIGHT_GRAY};
        cursor: not-allowed;
      }
    `}
`;

export const Pagination = styled.div`
  color: ${NEAR_WHITE};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: inline-flex;
  margin-right: 16px;
`;
